export const loadStudentLearnPage = () => import('@/pages/student/LearnPage');
export const loadStudentChatPage = () => import('@/pages/student/ChatPage');
export const loadStudentQuestsPage = () => import('@/pages/student/QuestsPage');
export const loadStudentPracticeModePage = () => import('@/pages/student/PracticeModePage');
export const loadStudentTestModePage = () => import('@/pages/student/TestModePage');
export const loadStudentResultsPage = () => import('@/pages/student/ResultsPage');
export const loadStudentCuriosityCentre = () => import('@/pages/student/CuriosityCentre');
export const loadStudentAdvancedTopicsPage = () => import('@/pages/student/AdvancedTopicsPage');
export const loadStudentChapterCuriosity = () => import('@/curiosity/pages/ChapterCuriosity');
export const loadStudentVideoPlayer = () => import('@/curiosity/pages/VideoPlayer');
export const loadStudentAudioPlayer = () => import('@/curiosity/pages/AudioPlayer');
export const loadStudentArticleDetailPage = () => import('@/pages/student/ArticleDetailPage');
export const loadStudentCourseContentPage = () => import('@/pages/student/CourseContentPage');
export const loadStudentContentDetailPage = () => import('@/curiosity/pages/ContentDetail');
export const loadStudentMathProblemsPage = () => import('@/pages/student/MathProblemsPage');
export const loadStudentProfilePage = () => import('@/pages/student/ProfilePage');
export const loadStudentLeaderboardPage = () => import('@/pages/student/LeaderboardPage');
export const loadStudentShopPage = () => import('@/pages/student/ShopPage');
export const loadStudentSettingsPage = () => import('@/pages/student/SettingsPage');
export const loadStudentTuitionsPage = () => import('@/pages/student/TuitionsPage');
export const loadStudentFoundersPage = () => import('@/pages/student/StudentFoundersPage');
export const loadStudentAnalyticsPage = () => import('@/pages/student/StudentAnalyticsPage');
export const loadAboutPage = () => import('@/pages/AboutPage');

const preloaderBySection = {
  learn: loadStudentLearnPage,
  chat: loadStudentChatPage,
  quests: loadStudentQuestsPage,
  'new-quest': loadStudentQuestsPage,
  ongoing: loadStudentQuestsPage,
  completed: loadStudentQuestsPage,
  drafts: loadStudentQuestsPage,
  curiosity: loadStudentCuriosityCentre,
  'curiosity-chapters': loadStudentCuriosityCentre,
  'curiosity-topics': loadStudentAdvancedTopicsPage,
  tuitions: loadStudentTuitionsPage,
  leaderboard: loadStudentLeaderboardPage,
  shop: loadStudentShopPage,
  founders: loadStudentFoundersPage,
  profile: loadStudentProfilePage,
  settings: loadStudentSettingsPage,
  'students-analytics': loadStudentAnalyticsPage,
  about: loadAboutPage,
};

const preloadCache = new Map();

export const preloadStudentRoute = (section) => {
  const loader = preloaderBySection[section];
  if (!loader) return null;

  if (!preloadCache.has(section)) {
    preloadCache.set(
      section,
      loader().catch((error) => {
        preloadCache.delete(section);
        throw error;
      })
    );
  }

  return preloadCache.get(section);
};

export const preloadCoreStudentRoutes = () => {
  ['learn', 'chat', 'quests', 'curiosity', 'curiosity-topics'].forEach((section) => {
    preloadStudentRoute(section)?.catch(() => {});
  });
};
